module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/nano_04-128e68384591643a9cd8a4937a45b62b.png";